import React from 'react';

import {
  Breadcrumbs,
  BusinessContactForm,
  BusinessTariffsCard,
  InternetBanner,
  TextBlock,
} from '@/ui/index';

import { Questions } from '../../roaming';

import styles from './Internet.module.scss';

const Internet = ({ data }) => {
  return (
    <div>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} dark />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} dark medium />
      )}
      <div className={'wrapper little-margin'}>
        <TextBlock className={styles.text}>
          Stay in contact with your beloved ones without touching your data via
          the free WhatsApp feature from roaming in more than 40 countries!
        </TextBlock>
      </div>
      {data?.offers && <BusinessTariffsCard data={data.offers} />}
      {data?.questions && (
        <Questions
          title={null}
          className={'wrapper section'}
          questions={data.questions}
        />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </div>
  );
};

export default Internet;
